export default "__VITE_ASSET__xze8Sg$7__"